(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["paralax-image"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ShopifyParallaxBlocksInitialized) return;
    window.ShopifyParallaxBlocksInitialized = true;

    let ticking = false;

    function updateParallaxBlocks() {
      ticking = false;

      const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      const viewportHeight =
        window.innerHeight || document.documentElement.clientHeight;

      document
        .querySelectorAll('[data-parallax-block]')
        .forEach((block) => {
          const media = block.querySelector('[data-parallax-media]');

          if (!media) return;

          if (reduceMotion) {
            media.style.transform = '';
            return;
          }

          const rect = block.getBoundingClientRect();

          if (rect.bottom < 0 || rect.top > viewportHeight) return;

          const strength = parseFloat(block.dataset.strength) || 150;

          /*
           * -1 when the block is below the viewport
           *  0 when centred in the viewport
           *  1 when above the viewport
           */
          const blockCenter = rect.top + rect.height / 2;
          const viewportCenter = viewportHeight / 2;
          const distance = viewportCenter - blockCenter;
          const travelRange = viewportHeight / 2 + rect.height / 2;
          const progress = distance / travelRange;

          const offset = progress * strength;

          media.style.transform =
            `translate3d(0, ${offset}px, 0)`;
        });
    }

    function requestParallaxUpdate() {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(updateParallaxBlocks);
    }

    window.addEventListener('scroll', requestParallaxUpdate, {
      passive: true
    });

    window.addEventListener('resize', requestParallaxUpdate, {
      passive: true
    });

    window.addEventListener('load', requestParallaxUpdate);

    document.addEventListener(
      'shopify:section:load',
      requestParallaxUpdate
    );

    document.addEventListener(
      'shopify:block:select',
      requestParallaxUpdate
    );

    document.addEventListener(
      'shopify:block:deselect',
      requestParallaxUpdate
    );

    requestParallaxUpdate();
  })();
  } catch(e) { console.error(e); }
})();

})();
